import axios from 'axios';
import Cookies from 'js-cookie';
import snackbar from '../snackbar';
/**
 * Api - Class representing axios instance.
 * Handles initial configuration and generic error handling
 */
class Api {
  constructor() {
    this.accessToken = null;
    this.appElement = document.getElementById('app');

    this.instance = axios.create({
      // Articles API will use current url as base url
      // baseUrl should be uncommented only when using in development enviroment
      // baseURL: 'http://sbxlv.libero.en/',
    });

    // Header for BE to destiquish between ajax calls and other type of requests
    this.instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    // Default Error handling
    this.instance.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err.response.status === 401) {
          if (err.response.data.redirectUrl) {
            window.location.href = err.response.data.redirectUrl;
          }
        } else if (err.response.status === 400) {
          snackbar.show(err.response.data.message);
        } else if (err.response.status === 500) {
          // Backend will render translated generic error message on initial page load
          snackbar.show(window.errorMessage);
        } else {
          snackbar.show(err.response.statusText);
        }
        return Promise.reject(err);
      },
    );

    // Set header access token or update if don't exists
    if (this.appElement) {
      this.accessToken = Cookies.get('bdp.fe');
      if (this.accessToken) {
        this.setToken(this.accessToken);
      }
    }
  }

  /**
   * Set Access token to header
   * @param {String} token Set Access token
   */
  setToken(token) {
    this.instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }

  /**
	 * Get method
	 * @param  {...any} params
	 */
  get(...params) {
    return this.instance.get(...params);
  }

  /**
	 * Post method
	 * @param  {...any} params
	 */
  post(...params) {
    return this.instance.post(...params);
  }

  /**
	 * Put method
	 * @param  {...any} params
	 */
  put(...params) {
    return this.instance.put(...params);
  }

  /**
	 * Patch method
	 * @param  {...any} params
	 */
  patch(...params) {
    return this.instance.patch(...params);
  }

  /**
	 * Delete method
	 * @param  {...any} params
	 */
  delete(...params) {
    return this.instance.delete(...params);
  }
}
const api = new Api();
export default api;
